'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
exports.SvgAnimation = void 0;
const Vivus = require("vivus");
class SvgAnimation {
    constructor() {
        // オトナ一年生 アニメーション
        new Vivus('bulletSvgMask', {
            type: 'oneByOne',
            start: 'inViewport',
            // start: 'autostart',
            duration: 200,
            // animTimingFunction: Vivus.EASE_OUT 	//アニメーションの終わるタイミングの動き
            animTimingFunction: Vivus.EASE //アニメーションの終わるタイミングの動き
        });
    }
}
exports.SvgAnimation = SvgAnimation;
exports.default = SvgAnimation;
